export const TOPICS = [
  { id: "supervised",   label: "Supervised Learning",  icon: "🎯", color: "#38BDF8" },
  { id: "unsupervised", label: "Unsupervised Learning", icon: "🔍", color: "#FB923C" },
  { id: "deeplearning", label: "Deep Learning",         icon: "🧠", color: "#C084FC" },
  { id: "cv",           label: "Computer Vision",       icon: "👁️", color: "#34D399" },
];

export const ROLES = [
  { id: "engineer",  label: "ML Engineer",    icon: "⚙️" },
  { id: "scientist", label: "Data Scientist",  icon: "🔬" },
  { id: "architect", label: "AI Architect",    icon: "🏗️" },
];

export const COMPANIES = [
  "Wells Fargo GCC", "Citi GCC", "Bosch", "JPMorgan GCC",
  "BMW Group", "Stellantis", "FAANG", "AI Startup",
];
